import { createAsyncThunk } from "@reduxjs/toolkit";
import { types } from "@vilocnv/allsetra-core";
import { RootState } from "app/store";
import { ObjectLocationReportedEventDto } from "domain/objects/entities/dtos/object-location-reported-event.dto";
import { mapObjectLocationReportedEventToObject } from "domain/objects/entities/mappers/map-object-location-reported-event-to-object.mapper";

const onObjectLocationReportedEventAction = createAsyncThunk<
  types.IObject | undefined,
  {
    objectLocationEventData: ObjectLocationReportedEventDto | undefined;
    accountId: string | null;
  },
  { state: RootState }
>("objects/v2/onObjectLocationReportedEvent", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { objectLocationEventData } = payload;

    if (!objectLocationEventData) {
      return;
    }

    const object = state.rootReducer.objectsStore.objects.find(
      (obj) => obj.uniqueId === objectLocationEventData?.uniqueId
    );

    // Patch selectedObject/markers from the event via the reducer only.
    // Do not re-fetch /map on every SignalR ping — that caused InfoWindow
    // loading flicker and Network Error toast floods when the endpoint failed.

    const newObject = mapObjectLocationReportedEventToObject(
      objectLocationEventData,
      object
    );

    return newObject;
  } catch (e: any) {
    throw new Error(e);
  }
});

export default onObjectLocationReportedEventAction;
